/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberShareDto { 
    id?: number;
    message?: string | null;
    creationTime?: string;
    amount?: number;
    balance?: number;
    transactionId?: string | null;
    allowedAsGuarantor?: boolean;
    allowedAsCollateral?: boolean;
    comment?: string | null;
}

